module.exports = "/_next/static/images/SendTheData@2x-f947842856b295e0c37097269857bf20.png";